import { Component, OnInit } from '@angular/core';
import { UtilsService } from '../utils.service'

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.css']
})
export class MainMenuComponent implements OnInit {

  constructor(public utils: UtilsService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/main-menu/main-menu.component.ts